import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")


const globalSearch = (term, limit=5) => http.get(`/global_search/${term}/${limit}`)


export default {
    globalSearch
}